import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { CalledFrom } from '../../../models/CalledFromEnum';
import { TrackedActions } from '../../../models/TrackedActionsEnum';
import useFilters from '../../../hooks/useFilters';
import { multiSelectStyle, DropdownIndicator } from '../FilterComponent.Styles';
import { trackActionClicked } from '../../../api/trackActionClickedApi';
import { buildPmrIdInitial, buildPmrOptions } from './utils';
import { useSelector } from 'react-redux';
import FilterProjects from '../../../models/FilterProjects';
import { getFilter } from '../UtilFunctions';
import { TagFilterContext } from '../../../context/TagFilterContext';

type Props = {
  indicatorCall: boolean;
  calledFrom: CalledFrom;
};
export const PmrFilter = (props: Props) => {
  const { indicatorCall, calledFrom } = props;
  const { t } = useTranslation();
  const {
    dispatch,
    filter,
    filterIndicators,
    filterEarlyWarnings,
    setFilter,
    setFilterIndicators,
    setFilterEarlyWarnings,
  } = useFilters();
  const { setTagOptions } = useContext(TagFilterContext);
  const currentFilter = useSelector<any, FilterProjects>(state => getFilter(state, calledFrom));
  const pmrOptions = buildPmrOptions(t);
  const pmrIdInitial = buildPmrIdInitial();

  const handleChange = value => {
    let pmrIdAux = [...pmrIdInitial];
    value?.forEach((el, i) => {
      let foundIndex = 0;
      foundIndex = pmrIdAux.findIndex(pmr => pmr.PmrClassification === el.value);
      pmrIdAux[foundIndex] = {
        ...pmrIdAux[foundIndex],
        selected: true,
      };
    });

    if (calledFrom === CalledFrom.EARLY_WARNINGS) {
      dispatch(
        setFilterEarlyWarnings({
          ...filterEarlyWarnings,
          common: {
            ...filterEarlyWarnings.common,
            pmrId: pmrIdAux,
          },
        }),
      );
      trackActionClicked(TrackedActions.pmrFilterChangedFromEarlyWarnings);
    } else {
      if (indicatorCall) {
        dispatch(
          setFilterIndicators({
            ...filterIndicators,
            common: {
              ...filterIndicators.common,
              pmrId: pmrIdAux,
            },
          }),
        );
        trackActionClicked(TrackedActions.pmrFilterChangedFromPortfolio);
      } else {
        dispatch(
          setFilter({
            ...filter,
            common: {
              ...filter.common,
              pmrId: pmrIdAux,
              itSearch: true,
            },
          }),
        );
        trackActionClicked(TrackedActions.pmrFilterChangedFromProject);
      }
    }
  };

  const getDefaultValue = () => {
    const optionsSelected = currentFilter.common.pmrId.filter(pmr => pmr.selected);

    if (optionsSelected.length === 0) {
      return [];
    }

    return pmrOptions.filter(option =>
      optionsSelected.some(selected => selected.PmrClassification === option.value),
    );
  }

  useEffect(() => {
    setTagOptions('pmr', getDefaultValue().map(option => {return option as any}));
  }, [currentFilter.common.pmrId, setTagOptions]);

  return (
    <Select
      key={currentFilter.common.pmrId.filter(pmr => pmr.selected)}
      id="pmrSelect"
      defaultValue={getDefaultValue()}
      isMulti
      components={{ DropdownIndicator }}
      name="pmr"
      options={pmrOptions}
      className="basic-multi-select"
      classNamePrefix="All"
      placeholder={t('all')}
      onChange={value => handleChange(value)}
      styles={multiSelectStyle}
    />
  );
};

export default PmrFilter;
